import React, { useEffect, useState, useContext } from 'react';
import BarcodeScannerComponent from "react-qr-barcode-scanner";
import Layout from 'components/sales/layout/layout';
import localization from 'assets/localization/localization';
import { BaseUrl } from 'contexts/baseUrl/baseUrl';
import CardSection from 'components/sales/cardSection/cardSection';
import DivLayout from 'components/sales/divLayout/divLayout';
import DropDownInput from 'components/sales/Input/dropDownInput/dropDownInput';
import ConstantInput from 'components/sales/Input/constantInput/constantInput';
import FileUpload from 'components/sales/fileUpload/fileUpload';
import "./asset.css";
import { toast } from 'react-toastify';
import ModalPop from 'components/sales/modal/modal';
import Images from 'assets/images/imageData';
import { Link } from 'react-router-dom';
import {handleValidateObjAssets} from 'constants/objValues/objvaluesAssets';

const NewSiteAssetMapping = ({
  history,
  match,
  getParentMaterialsBySiteId,
  parentMaterials,
  getAssetsAndMakeData,
  documentUploadUrlPublic,
  documentUrlDataPublic,
  saveSitesAssetsGateWise
}) => {
  const { baseUrl } = useContext(BaseUrl);
  const [isLoading, setIsLoading] = useState(false);
  const [material, setMaterials] = useState([]);
  const [gateIdentification, setGateIdentification] = useState("");
  const [gatePhoto, setGatePhoto] = useState('');
  const [remark, setRemark] = useState('');
  const [inputList, setInputList] = useState([{mat_id:'',mName:'',make:0,photo:'',specification:'',barCode:'',barCodeScanner:false,erp_barcode:'',assetData:[]}]);
  const [showBarCode, setShowBarCode] = useState(false);
  const [makeDropDown, setMakeDropDown] = useState([]);
  const [assetDetails, setAssetDetails] = useState([]);
  const [isSuccessModel, setIsSuccessModel] = useState(false);
  const [data, setData] = useState(null);
  const [checkDuplicate, setCheckDupicate] = useState([]);

  //console.log('PAGE:: NEW SITE ASSET MAPPING');
  //console.log(parentMaterials);
  useEffect(() => {
    if(getParentMaterialsBySiteId != '' && match.params.site_id != undefined) {
        (async () => {
            const data = await getParentMaterialsBySiteId(match.params.site_id);
            // if(data === false) {
            //   toast.error('Please complete hardware installation stage first.');             
            //   //setTimeout(history.push(`${baseUrl}/new-site-asset-mapping/${match.params.site_id}/${match.params.lead_id}`), 1000); 
            //   setTimeout(history.push(`${baseUrl}/site-listing`), 300); 
            
            // } 
        })();
    }
  },[getParentMaterialsBySiteId,match.params.site_id]);

  useEffect(() => {
      if(parentMaterials) {
         setMaterials(parentMaterials);
      }
  },[parentMaterials]);

  const getchildAssetsAndMake = (val,index) => {
    if(val.id != '') {
        (async () => {
           const data = await getAssetsAndMakeData(val.id);
           if(data && data?.make && data?.make.length > 0) {
              const makeValue = [...makeDropDown];
              makeValue[index] = data.make;
              //console.log('make-d ' + JSON.stringify(makeValue));
              setMakeDropDown([...makeValue]);
           } else {
              const makeValue = [...makeDropDown];
              makeValue[index] = [];
              delete makeValue[index];
              //console.log('make-d ' + JSON.stringify(makeValue));
              setMakeDropDown([...makeValue]);
           }
           if(data && data?.assets && data?.assets.length > 0) {
            const list = [...inputList];
            for(var i=0; i<data.assets.length; i++) {
             list[index]['assetData'][i] = {assetMatId:data?.assets[i]['material_id'],assetMatName:data?.assets[i]['material_name'],assetMakeId:'',assetBarCode:'',assetBarCodeScanner:false,assetPhoto:'',specification:'','make':data?.assets[i]['make']};
            }
            setInputList([...list]);
            setAssetDetails(data?.assets);
           } else {
            const list = [...inputList];
            list[index]['assetData'] = [];
            console.log(list);
            setInputList([...list]);
           }
        })();
    }
  }

  //console.log(assetDetails);

  const handleValue = (val,key,index,isCheck=true) => {
    var flag = false;
    const list = [...inputList];
    if(val !== '' && isCheck && key === 'barCode') {
      if(checkDuplicate.includes(val)) {
         list[index]['barCodeScanner'] = false;
         setInputList([...list]);
         toast.error('Barcode already scanned.');
         return false;
      } else { 
         checkDuplicate.push(val);
      }
    }
    if(key === 'mat') {
      // inputList.map((value,i) => {
      //   if(value['mat_id'] && (value['mat_id'] === val.id)) {
      //       toast.error('This material is already selected.');
      //       list.splice(index, 1);
      //       setInputList([...list]); 
      //       flag = true;
      //       return false;
      //   }
      // });
      if(flag) {
        //console.log('00000' + JSON.stringify(list));
        return false;
      } else {  
        list[index]['mat_id'] = val.id;
        list[index]['mName'] = val.value;
        let x = val.value;
        let ebc = x.split('~ ');
        list[index]['erp_barcode'] = (ebc[1] !== undefined && ebc[1] !== null && ebc[1] !== '') ? ebc[1] : 0;
        if(val.id != '') {
        (async () => {
          const data = await getAssetsAndMakeData(val.id);
          if(data && data?.make && data?.make.length > 0) {
           const makeValue = [...makeDropDown];
           makeValue[index] = data.make;
           setMakeDropDown([...makeValue]);
           } else {
               const makeValue = [...makeDropDown];
               makeValue[index] = [];
               delete makeValue[index];
               setMakeDropDown([...makeValue]);
           }
          if(data && data?.assets && data?.assets.length > 0) {
           const list = [...inputList];
           for(var i=0; i<data.assets.length; i++) {
            list[index]['assetData'][i] = {assetMatId:data?.assets[i]['material_id'],assetMatName:data?.assets[i]['material_name'],assetMakeId:'',assetBarCode:'',assetBarCodeScanner:false,assetPhoto:'',specification:'','make':data?.assets[i]['make']};
           }
           setInputList([...list]);
           setAssetDetails(data?.assets);
          } else {
           const list = [...inputList];
           list[index]['assetData'] = [];
           console.log(list);
           setInputList([...list]);
          }
       })(); 
      }
      }
    } else {
      list[index][key] = val;
    } 
    if(key === 'barCode') {
      list[index]['barCodeScanner'] = false; 
    }
    console.log(JSON.stringify(list));
    setInputList([...list]);
  };

  const handleValue2 = (val,key,parentIndex,childIndex,isCheckAsset=true) => {
    console.log(val + ' ' + key + ' ' + parentIndex + ' ' + childIndex);
    if(val) {
        //console.log(val + ' ' + key + ' ' + parentIndex + ' ' + childIndex);
        const list = [...inputList];
        if(val !== '' && isCheckAsset && key === 'assetBarCode') {  
          if(checkDuplicate.includes(val)) {
            list[parentIndex]['assetData'][childIndex]['assetBarCodeScanner'] = false;
             setInputList([...list]);
             toast.error('Barcode already scanned.');
             return false;
          } else {     
             checkDuplicate.push(val);
          }
        }
        list[parentIndex]['assetData'][childIndex][key] = val;
        if(key === 'assetBarCode') {
          list[parentIndex]['assetData'][childIndex]['assetBarCodeScanner'] = false; 
        }
        console.log('np' + JSON.stringify(list));
        setInputList([...list]);
    }
  }
 
  const handleAddClick = () => {
    setInputList([...inputList, {mat_id:'',mName:'',make:0,photo:'',specification:'',barCode:'',barCodeScanner:false,erp_barcode:'',assetData:[]}]);
  };

  const handleRemoveClick = index => {
    const list = [...inputList];
    list.splice(index, 1);
    setInputList(list);
  };

  const removeBarCode = (index,key,val) => {
    const list = [...inputList];
    list[index][key] = '';
    list[index]['barCodeScanner'] = false; 
    setInputList([...list]);
    if(val !== undefined) {
      const index = checkDuplicate.indexOf(val);
      if(index > -1) { 
         checkDuplicate.splice(index, 1); 
      }
    }
  }

  const removeAssetBarCode = (parentIndex,childIndex,key,val) => {
    const list = [...inputList];
    list[parentIndex]['assetData'][childIndex][key] = '';
    list[parentIndex]['assetData'][childIndex]['assetBarCodeScanner'] = false; 
    setInputList([...list]);
    if(val !== undefined) {
      const index = checkDuplicate.indexOf(val);
      if(index > -1) { 
         checkDuplicate.splice(index, 1); 
      }
    }
  }

  const handleShow = (index) => {
    const list = [...inputList];
    list[index]['barCodeScanner'] = !list[index]['barCodeScanner'];
    setInputList(list);
  };

  const handleAssetBarCodeShow = (parentIndex,childIndex) => {
    const list = [...inputList];
    list[parentIndex]['assetData'][childIndex]['assetBarCodeScanner'] = !list[parentIndex]['assetData'][childIndex]['assetBarCodeScanner'];
    console.log(JSON.stringify(list));
    setInputList(list);
  }

  const handleSiteAssets = async () => {
    const leadId = match?.params?.lead_id;
    const gateId = match?.params?.id;
    var isMaterialError, isAssetError = false;
    if(leadId && gateId && gateIdentification && gatePhoto) {
      let isNotEmpty = true;
      inputList.map((val,index) => {
        if (!handleValidateObjAssets(val)) {
          //toast.error('Please fill all meterial details.');
          isMaterialError = true;
          isNotEmpty = false;
          return false;
        }
        if(val.assetData.length > 0) { 
          val.assetData.map((v,i) => {
            if (!handleValidateObjAssets(v)) {
              //toast.error('Please fill all assets details.');
              isAssetError = true;
              isNotEmpty = false;
              return false;
            }
          }) 
        }
       });
       if(isMaterialError) {
        toast.error('Please fill all meterial details.');
        return false;
      }
      if(isAssetError) {
        toast.error('Please fill all assets details.');
        return false;
      }
       const payload = {
        'lead_id':leadId,
        'gate_id':gateId,
        'identifier': gateIdentification,
        'gate_photo':gatePhoto,
        'remark':remark,
        'data': inputList,
        'is_new_site':1
       }
      if(isNotEmpty !== false) {
        //console.log('here@callingFunctionThis.'); return false;
        setIsLoading(true);
        const res = await saveSitesAssetsGateWise(payload);
        //console.log(res);
        if(res == true) {
            localStorage.removeItem('inputListData');
            setIsLoading(false);
            setIsSuccessModel(true);
        } else {
          setIsLoading(false);
          toast.error('Someting went wrong, please try again.');
        }
        }
    } else {
        setIsLoading(false);
        toast.error('Mandatory fields are missing.');
    }
  }

  const handleRejectModalHide = () => setIsSuccessModel(false);


    //Native Scanner
    const handleMessageFromReactNative = (event) => {
      const dataFromReactNative = event.data;
      let arr = localStorage.getItem("inputListData");
      setInputList(JSON.parse(arr));
      setData(dataFromReactNative);
  };

  useEffect(() => {
    setTimeout(() => {
      if(data?.key != null) {
        if(data.childIndex != null) {
          handleValue2(data?.barcodeData,data?.key,data?.index,data?.childIndex);
        } else {
          console.log(inputList);
          handleValue(data?.barcodeData,data?.key,data?.index);
        }
        
      }
    }, 500);
  }, [data]);

  useEffect(() => {
    window.addEventListener("message", handleMessageFromReactNative);
  }, []);

  const openScanner = (key=null,index=null,childIndex=null) => {
    if(key !== null && index !== null) {
    setData(null);
    localStorage.setItem("inputListData", JSON.stringify(inputList));
    const RNWebView = window?.ReactNativeWebView;
      if (RNWebView) {
        const contentStr = {
          event: "OPEN_BAR_CODE_SCANNER",
          data: {
            key,index,childIndex
          },
          os: "ANDROID",
        };
        // localStorage.setItem("inputListData", inputList);
        RNWebView.postMessage(JSON.stringify(contentStr));
      }
    }
  };
  //End Native Scanner

  const successIconBox = (text, func) => {
    return (
      <div className="text-center">
        <div className="success">
          <img src={Images?.tick} alt="" />
        </div>
        <h5>{text}</h5>
        <Link to={`/dashboard/new-site-asset-mapping/${match.params.site_id}/${match.params.lead_id}`} onClick={func} className="btn btn-transparent">
          {localization.returnToListingPage}{' '}
          <img src={Images?.ArrowRight} alt="" />
        </Link>
      </div>
    );
  };

  return (
    <Layout
      title={localization.assetMapping}
      isLoading={isLoading}
      isGoback
      linkUrl={`${baseUrl}/new-site-asset-mapping/${match.params.site_id}/${match.params.lead_id}`}
    >
     <CardSection title={localization?.assets} >
     <div className='row'>
     <div className="col-md-6 col-sm-12 col-xs-12">
        <ConstantInput
            label='Gate Identification'
            type="text"
            value={''}
            handleChange={(val) =>
                setGateIdentification(val)
            }
            isStarRequired={true}
        />
    </div>
    <div className="col-md-6 col-sm-12 col-xs-12">
        <ConstantInput
            label='Remark'
            type="text"
            value={''}
            handleChange={(val) =>
                setRemark(val)
            }
            //isStarRequired={true}
        />
    </div>
    <div className="col-md-6 col-sm-12 col-xs-12">
        <FileUpload
            id={`gatePic`}
            accept=".png,.jpg,.jpeg"
            documentUploadUrl={documentUploadUrlPublic}
            documentUrlData={documentUrlDataPublic}
            onChange={(val) =>
                setGatePhoto(val)
            }
            multiple={true}
        >
        <span className="btn btn-transparent">
            {`Gate Photo`}
        </span>
        </FileUpload>
    </div> 
    <div className='breaker'></div>   
    {inputList.map((x, i) => {
        return (
        <>
        <div className='rowV1' style={{'padding':'15px 0px 15px 0px'}} key={i}>
        <div className='col-md-6'>
        <DropDownInput
            data={material}
            label={localization.parentMaterial}
            required
            errorMsg={localization.requiredName}
            getIdValue={(val) => {
                handleValue(val,'mat',i);
                //getchildAssetsAndMake(val,i);
            }}
            isStarRequired={true}
            value={x.mName ?? null}
        />
        </div>
        <div className='col-md-6'>
        <DropDownInput
            data={makeDropDown[i]}
            label={localization.make}
            required
            errorMsg={localization.requiredName}
            getIdValue={(val) => {
                handleValue(val.id,'make',i);
                //getchildAssetsAndMake(val);
            }}
            isStarRequired={true}
        />
        </div>
      <div className='col-md-6'>
      <ConstantInput
              label='Specification'
              type="text"
              value={x.specification ?? ``}
              handleChange={(val) =>
                handleValue(val,'specification',i)
              }
              isStarRequired={true}
            />
      </div>
        <div className='col-md-6'>
        <FileUpload
                id={`document${i}`}
                accept=".png,.jpg,.jpeg"
                documentUploadUrl={documentUploadUrlPublic}
                documentUrlData={documentUrlDataPublic}
                onChange={(val) =>
                    handleValue(val,'photo',i)
                }
                multiple={true}
            >
            <span className="btn btn-transparent">
                {localization.photo}
            </span>
        </FileUpload>
        </div>
        <div className='col-md-6 pb-15'>
        {x.barCodeScanner === true ? (
        {/* <BarcodeScannerComponent
            width={600}
            height={400}
            onUpdate={(err, result) => {
                if(result?.text) {
                 handleValue(result?.text,'barCode',i)
                }
            }}
         /> */}
        ) : x.barCode != '' && x.barCode != undefined ? 
        <button className='btn btn-green btn-sm'>{x.barCode} 
        <a className='remover'  onClick={() => removeBarCode(i,'barCode',x?.barCode)}>
        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="red" class="bi bi-x-circle" viewBox="0 0 16 16">
            <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z"/>
            <path d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708z"/>
        </svg>
        </a>
        </button> 
        :
        <button className='btn btn-primary' onClick={() => openScanner('barCode',i)}>Scan Barcode</button>}
        </div>

        <div className='col-md-6 pt-15'>
        <ConstantInput
            label='Enter barcode'
            type="text"
            value={x.barCode ?? ``}
            handleChange={(val) =>
              handleValue(val,'barCode',i,false)
              //handleChangeBarcode(x?.barCode)
            }
            //isStarRequired={true}
          />
        </div>
        
        {/* Asset Details */}
        {inputList[i]['assetData']?.length > 0 ? ( 
         <CardSection title={'Child Materials'}>
         <div>  
        {inputList[i]['assetData'] && inputList[i]['assetData'].map((k,j) => {
            return (
             <div className='row'>
             <div className="col-md-12 col-sm-12 col-xs-12">
             <ConstantInput
                label={`Child Material ${j+1}`}
                type="text"
                value={k.assetMatName}
                // handleChange={(val) =>
                //     handleValue2(val.id,'assetMatId',i,j)
                // }
                disabled={true}
                isStarRequired={true}
             />
             </div>
             <div className='col-md-6'>
             <DropDownInput
                data={k.make}
                label={localization.make}
                required
                errorMsg={localization.requiredName}
                getIdValue={(val) => {
                    handleValue2(val.id,'assetMakeId',i,j);
                }}
                isStarRequired={true}
             />
             </div>
             <div className="col-md-6 col-sm-12 col-xs-12">
                <ConstantInput
                    label='Specification'
                    type="text"
                    value={''}
                    handleChange={(val) =>
                        handleValue2(val,'specification',i,j)
                    }
                    isStarRequired={true}
                />
             </div>
             <div className='col-md-6'>
                <FileUpload
                id={`file${i}${i+j}`}
                accept=".png,.jpg,.jpeg"
                documentUploadUrl={documentUploadUrlPublic}
                documentUrlData={documentUrlDataPublic}
                onChange={(val) =>
                    handleValue2(val,'assetPhoto',i,j)
                }
                multiple={true}
                >
                <span className="btn btn-transparent">
                    {localization.photo}
                </span>
                </FileUpload>
             </div>
             <div className='col-md-6'>
                {k.assetBarCodeScanner === true ? (
                {/* <BarcodeScannerComponent
                    width={600}
                    height={400}
                    onUpdate={(err, result) => {
                        if(result?.text) {
                        handleValue2(result?.text,'assetBarCode',i,j)
                        }
                    }}
                /> */}
                ): k.assetBarCode != '' && k.assetBarCode != undefined ? 
                    <button className='btn btn-green btn-sm'>{k.assetBarCode} 
                    <a className='remover'  onClick={() => removeAssetBarCode(i,j,'assetBarCode',k?.assetBarCode)}>
                    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="red" class="bi bi-x-circle" viewBox="0 0 16 16">
                        <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z"/>
                        <path d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708z"/>
                    </svg>
                    </a>
                    </button> 
                    :<button className='btn btn-primary' onClick={() => openScanner('assetBarCode',i,j)}>Open Scanner</button>}
             </div>
             <div className="col-md-6 col-sm-12 col-xs-12 pt-15">
                <ConstantInput
                    label='Enter barcode'
                    type="text"
                    value={k.assetBarCode ?? ``}
                    handleChange={(val) =>
                        handleValue2(val,'assetBarCode',i,j,false)
                    }
                    isStarRequired={true}
                />
             </div>
             <div className='make-space'></div>
             </div>
            )
          })}
          </div>
         </CardSection>
        ):null}
        {/* End */}
        </div>

        <div className="col-md-3 col-sm-12 d-flex" style={{'padding':'0px 0px 20px 0px'}}>
         {inputList.length !== 1 && 
            <div className="col-md-2 col-sm-5">
                <button
                onClick={() => handleRemoveClick(i)} 
                className="mr10 btn btn-sm btn-danger">Remove</button>
                </div>
                }
                {inputList.length - 1 === i && 
                <div className="col-md-2 col-sm-5">
                <button className="btn btn-sm btn-primary" onClick={handleAddClick}>Add</button>
            </div>
         }
        </div>
        </>
        )
        })}
      
     </div>
     </CardSection>
     <div className="form-group col-10">
        <button
        type="button"
        className="btn btn-primary"
        onClick={() => handleSiteAssets()}
        >
        {'Submit Assets'} <img src="" alt="" />
        </button>
     </div>
     <ModalPop
        title={localization.success}
        show={isSuccessModel}
        handleModalHide={handleRejectModalHide}
      >
        {successIconBox(localization.assetSuccess, handleRejectModalHide)}
      </ModalPop>
    </Layout>
  );
};

export default NewSiteAssetMapping;
